import { Button } from '@radix-ui/themes'
import { useNavigate, useRouter } from '@tanstack/react-router'
import ArrowLeft from 'assets/arrow-left.svg?react'
import ChevronRight from 'assets/chevron-right.svg?react'
import { MaxWidthEnforcer, usePageMaxWidth } from 'components/CantileverPage'
import React from 'react'
import styled from 'styled-components'
import { capitalizeText } from 'utils/stringHelpers'

const BorderContainer = styled.div<{ $border: boolean }>`
  border-bottom: ${({ $border, theme }) =>
    $border ? `1px solid ${theme.forecast.cardDividerBackground}` : 'none'};
`

const NavBar = styled.div<{ $padding?: string }>`
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${({ theme }) => theme.forecast.secondaryText};
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  padding: ${({ $padding }) => $padding || '0'};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ClickableBreadcrumb = styled(Button)`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.forecast.defaultText};
  }

  &:active {
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

const ArrowLeftIcon = styled(ArrowLeft)`
  height: 16px;
  width: 16px;
  margin: 0 4px 0 0;
`

const TabNameText = styled.div`
  margin: 0 2px 0 2px;
`

const ChevronRightIcon = styled(ChevronRight)`
  height: 16px;
  width: 16px;
  margin: 0 2px 0 2px;
`

const AssetNameText = styled.div`
  cursor: default;
  margin: 0 2px 0 2px;
`

export const BreadcrumbBar: React.FC<{
  lastPage?: string
  currentPage: string
  navigateTo?: string
  params?: Record<string, string>
  border?: boolean
  padding?: string
  capitalizePageNames?: boolean
}> = ({
  lastPage = 'assets',
  currentPage,
  navigateTo,
  border = true,
  padding,
  capitalizePageNames = true,
  params,
}) => {
  const { maxWidth } = usePageMaxWidth()
  const navigate = useNavigate()
  const router = useRouter()

  const handleNavigation = () => {
    if (navigateTo) {
      navigate({ to: navigateTo, params })
    } else {
      router.history.back()
    }
  }

  return (
    <BorderContainer $border={border}>
      <MaxWidthEnforcer $maxWidth={maxWidth}>
        <NavBar $padding={padding}>
          <ClickableBreadcrumb onClick={handleNavigation}>
            <ArrowLeftIcon />
            <TabNameText>
              {capitalizePageNames ? capitalizeText(lastPage) : lastPage}
            </TabNameText>
          </ClickableBreadcrumb>
          <ChevronRightIcon />
          <AssetNameText>
            {capitalizePageNames ? capitalizeText(currentPage) : currentPage}
          </AssetNameText>
        </NavBar>
      </MaxWidthEnforcer>
    </BorderContainer>
  )
}
